'use client';

import { cn } from '@/shared/utils/utils';

interface SectionHeaderProps {
  title: string;
  subTitle?: string;
  className?: string;
  rightContent?: React.ReactNode;
}
export const SectionHeader = ({
  title,
  subTitle,
  className,
  rightContent,
}: SectionHeaderProps) => {
  return (
    <div
      className={cn(
        'flex justify-between items-center md:items-center gap-4 md:gap-8',
        className,
      )}
    >
      <div className="flex flex-col gap-1">
        <h2 className="text-2xl font-bold tracking-tight">{title}</h2>
        <p className="text-gray-500 dark:text-gray-400">{subTitle}</p>
      </div>
      {rightContent && (
        <div className="shrink-0 md:ml-auto">{rightContent}</div>
      )}
    </div>
  );
};
